import { render, staticRenderFns } from "./AdditionalVisitors.vue?vue&type=template&id=5daad08c&"
import script from "./AdditionalVisitors.vue?vue&type=script&lang=js&"
export * from "./AdditionalVisitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports